import Vue from 'vue'
// models component
import App from '@/models/App'
import SelectShipJob from '@/models/SelectShipJob'
import SelectShipCountry from '@/models/SelectShipCountry'
import SelectShipType from '@/models/SelectShipType'
import SelectShipSkill from '@/models/SelectShipSkill'

export default class Initialize {
    // Ship Management Service Initialize
    static of(maritimeId) {
        return Promise.resolve()
            .then(function () {
                if (!App.one()) {
                    App.of('attend')
                    if (maritimeId) {
                        let key = `${maritimeId}/T`
                        App.setToken(localStorage.getItem(key))
                    } else {
                        App.setToken('')
                    }
                }
            })
            .then(function () {
                return SelectShipJob.api()
                    .fetch()
                    .then(function (result) {
                        // console.log('SelectShipJob.all()', SelectShipJob.all())
                    })
            })
            .then(function () {
                return SelectShipCountry.api()
                    .fetch()
                    .then(function (result) {
                        // console.log('SelectShipCountry.all()', SelectShipCountry.all())
                    })
            })
            .then(function () {
                return SelectShipType.api()
                    .fetch()
                    .then(function (result) {
                        // console.log('SelectShipType.all()', SelectShipType.all())
                    })
            })
            .then(function () {
                return SelectShipSkill.api()
                    .fetch()
                    .then(function (result) {
                        // console.log('SelectShipSkill.all()', SelectShipSkill.all())
                    })
            })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
